export const BASKET_UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
export const CD_ORDER_SOURCE_REGEX = /mpuid=CD/;



// WEBPACK FOOTER //
// ./constants/regex.js